import { simpleLookupManagementConfig } from "../../../../records/lookup/utils/simpleLookupManagementConfig";
import { vsLookupManagementServiceProviderName } from "./lookupManagement";

export const vsObjectName = "gamingContractPaymentTerm";

const url = "api/contract/gamingContract/paymentTerm";

export const PaymentTermConfig = simpleLookupManagementConfig({
  lookupEditPermission: "contractLookupModify",
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
  nameSingular: "Payment Term",
  namePlural: "Payment Terms",
  objectName: vsObjectName,
  url,
});
